import React from "react";
import "./App.css";
import "./styles/pages.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import About from "./pages/About";
import EdibleCupsCategory from "./pages/EdibleCupsCategory";
import EdibleCup220 from "./pages/EdibleCup220";
import EdibleCup110 from "./pages/EdibleCup110";
import CutleryTableware from "./pages/CutleryTableware";
import Certifications from "./pages/Certifications";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Shop from "./pages/Shop";
import Account from "./pages/Account";
import OrderConfirmation from "./pages/OrderConfirmation";
import ScrollToTop from "./components/ScrollToTop";
import TermsConditions from "./components/legal/TermsConditions";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import CookiePolicy from "./components/legal/CookiePolicy";
import DeliveryReturn from "./components/legal/DeliveryReturn";
import CookieConsent from "./components/CookieConsent";


function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Header />
              <CartDrawer />
              <CookieConsent />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/edible-cups" element={<EdibleCupsCategory />} />
                  <Route path="/edible-cup-220" element={<EdibleCup220 />} />
                  <Route path="/edible-cup-110" element={<EdibleCup110 />} />
                  <Route path="/cutlery-tableware" element={<CutleryTableware />} />
                  <Route path="/certifications" element={<Certifications />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/order-confirmation" element={<OrderConfirmation />} />
                  <Route path="/terms-conditions" element={<TermsConditions />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/cookie-policy" element={<CookiePolicy />} />
                  <Route path="/delivery-return" element={<DeliveryReturn />} />
                </Routes>
              </main>
              <Footer />
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
